/// <amd-module name="Artifacts/Connect/tools/nuget/VisualStudio" />
import { CopyableCode, DetailsCard } from "Artifacts/Connect/components/Common";
import * as Res from "Artifacts/Connect/Resources";
import { PackagingService, TfsService } from "Artifacts/Connect/services/PackagingService";
import { ToolService } from "Artifacts/Connect/services/ToolService";
import { IToolConnectProps } from "Artifacts/Connect/tools/IToolConnectProps";
import { NugetProtocol } from "Artifacts/Connect/tools/nuget/Protocol";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { ITool, ToolId } from "Artifacts/Connect/types/ITool";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPageData } from "VSS/Platform/Page";

const VisualStudioConnect: React.FC<IToolConnectProps<NugetProtocol>> = ({
  protocol,
  feed: feed,
  packagingService,
}) => {
  const name = feed.name;
  const url = protocol.getFeedUrl(packagingService, feed);

  return (
    <React.Fragment>
      <DetailsCard title={{ text: Res.MachineSetup, ariaLevel: 3 }}>
        <p>{Res.MachineSetup_VisualStudio_Details}</p>
        <p>{Res.Name}</p>
        <CopyableCode ariaLabel={Res.MachineSetup + " " + Res.Name}>{name}</CopyableCode>
        <p>{Res.Source}</p>
        <CopyableCode ariaLabel={Res.MachineSetup + " " + Res.Source}>{url}</CopyableCode>
        <p className="body-s">{Res.MachineSetup_VisualStudio_Note}</p>
      </DetailsCard>

      <DetailsCard title={{ text: Res.RestorePackages, ariaLevel: 3 }}>
        <p>{Res.RestorePackages_VisualStudio_Details}</p>
        <p>{Res.ForExample}</p>
        <CopyableCode ariaLabel={Res.RestorePackages}>Install-Package NUnit</CopyableCode>
      </DetailsCard>
    </React.Fragment>
  );
};

class VisualStudioTool implements ITool {
  readonly id = ToolId.VisualStudio;
  readonly name = "Visual Studio";
  readonly protocol = new NugetProtocol();
  readonly allowNonMembers = true;
  readonly imagePath = `ms.azure-artifacts/connect/img/visual-studio-2019.svg`;
  readonly Component: React.ComponentType = VisualStudioConnect;

  isEnvironmentSupported(pageData: IPageData): boolean {
    return true;
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return true;
  }

  supportsGet(): boolean {
    return true;
  }

  supportsPush(feed: ICombinedFeedView): boolean {
    return feed.canPublishPackages;
  }

  renderComponent(
    pageContext: IVssPageContext,
    feed: ICombinedFeedView,
    packagingService: PackagingService,
    tfsService: TfsService,
  ): JSX.Element {
    return (
      <VisualStudioConnect
        pageContext={pageContext}
        protocol={this.protocol}
        feed={feed}
        packagingService={packagingService}
        tfsService={tfsService}
      />
    );
  }

  getToolLink = () => ({
    href: `https://go.microsoft.com/fwlink/?linkid=2103786`,
    children: Res.LearnAboutRestore,
  });
}

ToolService.registerTool(new VisualStudioTool());
